export enum ErrorEnum {
  UserNotFound = 'User not found',
  NotAccepted = 'Username or Password not accepted',
  TokenExpired = 'Token expired',
  PasswordChangeRequired = 'Password change required'
}
